//REACT
import React from 'react'

// @material-ui/icons
import InfoIcon from '@material-ui/icons/Info';
import RoomIcon from '@material-ui/icons/Room';
import GavelIcon from '@material-ui/icons/Gavel';
//Secciones
import Cabecera from "../CabeceraPie/Cabecera"
import PiePagina from "../CabeceraPie/PiePagina"

import Carrusel from "pages/Home/sections/Carrusel"
import NavPills from "components/NavPills/NavPills"
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";

export default function IndexHome() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    window.localStorage.clear()
    window.sessionStorage.clear()
  });

  return (
    <div>
      <Cabecera color="transparent" />
        <Carrusel />
        <GridContainer justify="center">  
          <GridItem xs={12} sm={12} md={6}>     
            <NavPills
              alignCenter
              color="primary"
              tabs={[
                {
                  tabButton: "Misión",
                  tabIcon: InfoIcon,
                  tabContent: (
                    <Card style={{padding:"20px"}}>
                      <span>
                        <p>                 
                          Proveer de soluciones digitales que permitan efectuar transacciones electrónicas seguras, confiables y no repudiables entre personas y empresas.
                        </p>
                      </span>
                    </Card>
                  )
                },
                {
                  tabButton: "Visión",
                  tabIcon: RoomIcon,
                  tabContent: (
                    <Card style={{padding:"20px"}}>
                      <span>
                        <p>
                          Contribuir a que el país genere una economía basada en procesos digitales confiables.
                        </p>
                      </span>
                    </Card>
                  )
                },
                {
                  tabButton: "Valores",
                  tabIcon: GavelIcon,
                  tabContent: (
                    <Card style={{padding:"20px"}}>
                      <span>
                        <p>
                          Integridad y Responsabilidad: 
                        <br/>
                        </p>
                        <p>
                          -Ética: Conducir las relaciones con probidad y honestidad, entregando nuestros servicios en un marco legal, moral y social.
                        </p>
                        <br />
                        <p>
                          -Honestidad y Transparencia: Hacemos lo que decimos que vamos a hacer para mejorar la gestión administrativa y operacional de nuestros clientes, con sentido común y respetando la legislación.
                        </p>
                        <br />
                        <p>
                          -Orientación al Cliente: Son el centro de la organización. Trabajamos para atender sus necesidades. Todos nuestros recursos y esfuerzos están enfocados en esta dirección.
                        </p>
                      </span>
                    </Card>
                  )
                }
              ]}
            />
          </GridItem>   
        </GridContainer>        
      <PiePagina />
    </div>
  )
}